import { createRouter, createWebHashHistory } from '@ionic/vue-router'
import { RouteRecordRaw } from 'vue-router'

import HomePage from '@/views/HomeView.vue'
import HelpPage from '@/views/HelpView.vue'
import TabsPage from '@/views/TabsPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: HomePage
  },
  {
    name: 'help',
    path: '/help',
    component: HelpPage
  },
  {
    path: '/incidencias/',
    component: TabsPage,
    children: [
      {
        path: '',
        redirect: '/incidencias/create'
      },
      {
        name: 'create',
        path: 'create/:id?',
        component: () => import('@/views/form/FormCategories.vue')
      },
      {
        name: 'images',
        path: 'images/:timestamp',
        component: () => import('@/views/form/FormImages.vue')
      },
      {
        name: 'location',
        path: 'location/:timestamp',
        component: () => import('@/views/form/FormLocation.vue')
      },
      {
        name: 'user-data',
        path: 'user-data/:timestamp',
        component: () => import('@/views/form/FormData.vue')
      },
      {
        name: 'resume',
        path: 'resume/:timestamp',
        component: () => import('@/views/form/FormResume.vue')
      },
      {
        name: 'post',
        path: 'post/:timestamp',
        component: () => import('@/views/form/FormPost.vue')
      },
      {
        name: 'list',
        path: 'list',
        component: () => import('@/views/ListView.vue'),
      },
      {
        name: 'detail',
        path: 'item/:id',
        component: () => import('@/views/DetailView.vue')
      },
      {
        name: 'actions',
        path: 'actions/:id',
        component: () => import('@/views/ActionsView.vue')
      },
      {
        name: 'map',
        path: 'map',
        component: () => import('@/views/MapView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
